@import '../../../../../style/lib/scss';
@import '../../../../../style/src/typography/mixins';
@import '../mixins';

:host {
	@include zds-typography('body');

	display: block;
}

.zds-navigation-panel {
	display: flex;
	gap: var(--zds-space-16);

	&__body-link {
		flex-grow: 1;

		@include zds-media-breakpoint-up('md') {
			flex-grow: 0;
			flex-shrink: 0;
			max-width: 330px;
			width: 28%;
		}
	}

	&__panel {
		display: none;
		position: fixed;
		width: 100%;

		@include zds-media-breakpoint-down('sm') {
			background: var(--zds-navigation-background);
			inset: 0;
			overflow: hidden auto;
			overscroll-behavior: contain;
			overscroll-behavior-block: contain;
			transform: translateX(calc(100% - 10px));
			transition:
				transform 300ms var(--zds-transition-type-ease-in),
				opacity 300ms var(--zds-transition-type-ease-in);
			z-index: 1;

			&--open,
			&--opened {
				transform: none;
			}
		}

		@include zds-media-breakpoint-up('md') {
			opacity: 0;
			position: static;
			transition:
				transform 200ms linear,
				opacity 200ms linear;

			&--open,
			&--opened {
				opacity: 1;
				transition-duration: 300ms;
			}
		}
	}

	&__body {
		padding: var(--zds-space-3) var(--zds-space-4);

		@include zds-media-breakpoint-up('md') {
			inset: var(--zds-space-8) 0 0 calc(min(28%, 330px) + var(--zds-space-16)); // Left is same as navigation-body 'left' column width + gap
			padding-block: 0;
			position: absolute;
		}
	}

	@include navigation-body-title;
}
